/* eslint-disable */
import React, { useState, useEffect, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import SimpleSnackbar from '../../../Components/Snackbar/snackbar';
import CommonTextField from '../../../Components/TextField/textField';
import TextField from '@mui/material/TextField';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import FormDialog from '../../../Components/Modal/modal';
import debounce from 'lodash.debounce';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/en';
import './addEditMap.scss';
import { parse, format } from 'date-fns';
dayjs.extend(customParseFormat);
import CommonDatePicker from '../../../Components/Datepicker/datepicker';
import {
  ADD_EDIT_DIALOG,
  CANCEL_TEXT,
  ADD_EDIT_RESPONSE_MESSAGES,
  MAP_EDIT_CERTIFICATION_DIALOG,
  SAVE,
  UPDATE,
  AUTHENTICATION_FAILED,
  NOTE,
} from '../../../Constants/strings';
import { AuthContext } from '../../../Contexts/AuthContext';
import {
  fetchUserInfoFromZoho,
  convertEmployeeStatusToValue,
} from './fetchUserInfo';
import {
  handleDateChangeUtil,
  submitAction,
  fetchCertifications,
  setMapRowData,
  enableSaveAction,
} from './utils';
import ProfilePicPlaceHolder from '../../../Assets/images/png/profil-pic-placeholder-large.png';
import { makeStyles } from '@mui/styles';
import { CircularProgress } from '@mui/material';
dayjs.locale({
  ...dayjs.Ls.en,
  formats: {
    ...dayjs.Ls.en.formats,
    L: 'DD-MM-YYYY',
  },
});

const CertificationsMap = ({
  handleClose,
  modalOpen,
  setRows,
  isEditMode,
  editItem,
  setIsEdit
}) => {
  const [severity, setSeverity] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [employeeNameValue, setEmployeeNameValue] = useState('');
  const [employeeEmailValue, setEmployeeEmailValue] = useState('');
  const [employeeIDValue, setEmployeeIDValue] = useState('');
  const [employeeStatusValue, setEmployeeStatusValue] = useState('');
  const [employeeVerticalValue, setEmployeeVerticalValue] = useState('');
  const [certifications, setCertifications] = useState([]);
  const [certificationNameError, setCertificationNameError] = useState('');
  const [achievedDateError, setAchievedDateError] = useState('');
  const [expiryDateError, setExpiryDateError] = useState('');
  const [newCertification, setNewCertification] = useState(null);
  const [certificationAchievedDateValue, setCertificationAchievedDateValue] =
    useState(null);
  const [certificationsvalidity, setCertificationsvalidity] = useState('');
  const [expiryDateValue, setExpiryDateValue] = useState(null);
  const { userProfile } = useContext(AuthContext);
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [loadingEmployeeList, setLoadingEmployeeList] = useState(false);
  const [achievedDateValue, setAchievedDateValue] = useState(null);
  const [employeeAutocompleteError, setEmployeeAutocompleteError] =
    useState('');
  const useStyles = makeStyles({
    noOptions: {
      display: 'none',
    },
  });
  const styles = useStyles();
  let isSaveButtonEnabled = enableSaveAction(
    isEditMode, 
    editItem, 
    {
      employeeID: employeeIDValue,
      certificationID: newCertification?.id,
      certificationExpiryDate: certificationsvalidity,
    },
    newCertification?.validity,
    certificationAchievedDateValue
  );

  useEffect(() => {
    fetchCertifications().then(setCertifications);
  }, []);

  useEffect(() => {
    if (isEditMode) {
      setInitialValues(editItem);
    } else {
      setSelectedEmployee({});
      setEmployeeSuggestions([]);
    }
  }, [isEditMode, editItem, certifications]);

  const setIntialCertification = async () => {
    if (isEditMode && editItem) {
      const matchedCertification = await certifications.find(
        (certification) => certification.id === editItem.certificationId,
      );

      if (matchedCertification) {
        matchedCertification.achievedDate = editItem.achievedDate;
        await setNewCertification(matchedCertification); // NOSONAR
      }
    }
  };

  const setInitialValues = async (editItem = null) => {
    setEmployeeNameValue(editItem?.userName ?? '');
    setEmployeeEmailValue(editItem?.userEmail ?? '');
    setEmployeeIDValue(editItem?.userId ?? '');
    setEmployeeStatusValue(editItem?.employeeStatus ?? '');
    setEmployeeVerticalValue(editItem?.vertical ?? '');
    await setIntialCertification();

    let data = {
      fullName: editItem.userName,
      emailId: editItem.userEmail,
      employeeId: editItem.userId,
      employeestatus: editItem.employeeStatus,
      vertical: editItem.vertical,
    };
    await setEmployeeSuggestions([data]); // NOSONAR
    await setSelectedEmployee(data); // NOSONAR
  };

  const handleCloseWithReset = () => {
    setIsEdit(false)
    handleClose();
    resetValues();
    
  };

  const resetValues = () => {
    setEmployeeNameValue('');
    setEmployeeEmailValue('');
    setEmployeeIDValue('');
    setNewCertification(null);
    setCertificationNameError('');
    setAchievedDateError('');
    setExpiryDateError('');
    setCertificationAchievedDateValue(null);
    setCertificationsvalidity('');
    setExpiryDateValue(null);
    setEmployeeStatusValue('');
    setEmployeeVerticalValue('');
    setEmployeeAutocompleteError('');
    setSelectedEmployee({});
    setEmployeeSuggestions([]);
    setAchievedDateValue(null);
    if(!isEditMode && editItem){
      setInitialValues(editItem);
    }
  
  };

  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };

  useEffect(() => {
    if (newCertification?.achievedDate && editItem) {
      // In edit mode, preserve the original expiry date instead of recalculating
      // First check if the expiry date is "N/A" as a string or null/empty
      if (!editItem.expiredDate || editItem.expiredDate === 'N/A' || editItem.expiredDate === '') {
        setCertificationAchievedDateValue(dayjs(newCertification.achievedDate));
        setCertificationsvalidity('N/A');
        setExpiryDateValue(null);
      } else {
        const expiryDate = new Date(editItem.expiredDate);
        // Check if it's a valid date and not Unix epoch (Jan 1, 1970)
        if (!isNaN(expiryDate) && expiryDate.getTime() !== 0) {
          setCertificationAchievedDateValue(dayjs(newCertification.achievedDate));
          setCertificationsvalidity(dayjs(editItem.expiredDate).format('DD-MM-YYYY'));
          setExpiryDateValue(dayjs(editItem.expiredDate));
        } else {
          setCertificationAchievedDateValue(dayjs(newCertification.achievedDate));
          setCertificationsvalidity('N/A');
          setExpiryDateValue(null);
        }
      }
    }
  }, [newCertification]);

  const handleDateChange = async (date) => {
    if (date) {
      const year = dayjs(date).year();
      if (year >= 2000 && year <= 2099) {
        setAchievedDateValue(date);
        if (newCertification) {
          // Check if certification has validity (expiry date)
          if (newCertification.validity) {
            // Certification has expiry - calculate new expiry date
            const { valid, achievedDate, formattedExpiryDate } =
              await handleDateChangeUtil(date, newCertification, editItem);
            if (valid) {
              setCertificationAchievedDateValue(achievedDate);
              setCertificationsvalidity(formattedExpiryDate);
              setExpiryDateValue(dayjs(formattedExpiryDate, 'DD-MM-YYYY'));
              setAchievedDateError('');
              setExpiryDateError('');
            } else {
              setCertificationAchievedDateValue(dayjs(date));
              setCertificationsvalidity('N/A');
              setExpiryDateValue(null);
              setAchievedDateError('');
            }
          } else {
            // Certification has no expiry - keep "N/A" and just update achieved date
            setCertificationAchievedDateValue(dayjs(date));
            setCertificationsvalidity('N/A');
            setExpiryDateValue(null);
            setAchievedDateError('');
          }
        }
      } else {
        setAchievedDateError('Year must be between 2000 and 2099');
        setAchievedDateValue(null);
        setCertificationAchievedDateValue(null);
        setCertificationsvalidity('');
        setExpiryDateValue(null);
      }
    }
  };
  const handleCertificationChange = async (event) => {
    const selectedCertification = event.target.value;
    setNewCertification(selectedCertification);
    setCertificationNameError('');

    // Use achievedDateValue if available, otherwise use certificationAchievedDateValue for edit mode
    const dateToUse = achievedDateValue || certificationAchievedDateValue;
    
    if (dateToUse) {
      // Don't pass editItem when changing certifications - we don't want to use old expiry date
      const { valid, achievedDate, formattedExpiryDate } =
        await handleDateChangeUtil(
          dateToUse,
          selectedCertification,
          null, // Pass null instead of editItem to avoid using old expiry date
        );
      if (valid) {
        setCertificationAchievedDateValue(achievedDate);
        setCertificationsvalidity(formattedExpiryDate);
        setExpiryDateValue(dayjs(formattedExpiryDate, 'DD-MM-YYYY'));
      } else {
        // Even if validity is not available, set the achieved date for validation
        setCertificationAchievedDateValue(achievedDate || dayjs(dateToUse));
        setCertificationsvalidity('N/A');
        setExpiryDateValue(null);
      }
    } else {
      // If no date is available, just clear the expiry date
      setCertificationsvalidity('');
      setExpiryDateValue(null);
    }
  };

  const handleExpiryDateChange = (date) => {
    if (date) {
      const year = dayjs(date).year();
      if (year >= 2000 && year <= 2099) {
        // Validate that expiry date is after achieved date
        if (certificationAchievedDateValue && dayjs(date).isBefore(certificationAchievedDateValue, 'day')) {
          setExpiryDateError('Expiry date must be after achieved date');
          setExpiryDateValue(null);
          setCertificationsvalidity('N/A');
        } else {
          setExpiryDateValue(date);
          setCertificationsvalidity(dayjs(date).format('DD-MM-YYYY'));
          setExpiryDateError('');
        }
      } else {
        setExpiryDateError('Year must be between 2000 and 2099');
        setExpiryDateValue(null);
        setCertificationsvalidity('N/A');
      }
    } else {
      // Allow clearing the expiry date (for certifications with no expiry)
      setExpiryDateValue(null);
      setCertificationsvalidity('N/A');
      setExpiryDateError('');
    }
  };

  const handleSubmit = async () => {
    const employeeAutocompleteError =
      employeeNameValue.trim() === '' ? 'Please fill the required field' : '';
    const certificationNameError = !newCertification?.name
      ? 'Please fill the required field'
      : '';
    const achievedDateError = !certificationAchievedDateValue
      ? 'Please fill the required field'
      : '';

    setEmployeeAutocompleteError(employeeAutocompleteError);
    setCertificationNameError(certificationNameError);
    setAchievedDateError(achievedDateError);

    if (
      employeeAutocompleteError ||
      certificationNameError ||
      achievedDateError ||
      expiryDateError
    )
      return;

    try {
      let formattedExpiryDate = null;
      
      if (certificationsvalidity && certificationsvalidity !== 'N/A') {
        const dateFormat = 'dd-MM-yyyy';
        const parsedExpiryDate = parse(
          certificationsvalidity,
          dateFormat,
          new Date(),
        );
        formattedExpiryDate = format(
          parsedExpiryDate,
          'yyyy-MM-dd hh:mm:ss',
        );
      }

      const submitData = {
        employeeName: employeeNameValue,
        employeeEmail: employeeEmailValue,
        employeeID: employeeIDValue,
        vertical: employeeVerticalValue,
        employeeStatus: employeeStatusValue || false,
        certificationID: newCertification.id,
        certificationAchievedDate: dayjs(certificationAchievedDateValue).format('YYYY-MM-DD HH:mm:ss'),
        certificationExpiryDate: formattedExpiryDate,
        lastUpdatedBy: userProfile.user_name,
        ...(isEditMode && { id: editItem.id }),
      };

      const response = await submitAction(submitData, isEditMode);

      if (response.data.status === 200) {
        setRows((prevRows) => {
          if (!isEditMode) {
            return [
              ...prevRows,
              {
                ...setMapRowData(submitData, newCertification),
                id: response.data.certificationID || new Date().getTime(),
              },
            ];
          } else {
            return prevRows.map((row) =>
              row.id === response.data.id
                ? { ...setMapRowData(submitData, newCertification, row) }
                : row,
            );
          }
        });

        snackbarOpen();
        setSnackbarMessage(
          isEditMode
            ? MAP_EDIT_CERTIFICATION_DIALOG.EDIT.SUCCESS_MESSAGE
            : MAP_EDIT_CERTIFICATION_DIALOG.MAP.SUCCESS_MESSAGE,
        );
        setSeverity('success');
      } else {
        throw response.data.response;
      }
    } catch (error) {
      const errorMessage = (() => {
        if (error.data && error.data.status === 400) {
          return (
            error.data.message || ADD_EDIT_RESPONSE_MESSAGES.VALIDATION_ERROR
          );
        } else if (error.status === 401) {
          return AUTHENTICATION_FAILED;
        } else {
          return MAP_EDIT_CERTIFICATION_DIALOG.SUBMIT_FAILURE_MESSAGE;
        }
      })();
      setSnackbarMessage(errorMessage);
      setSeverity('warning');
    } finally {
      snackbarOpen();
      handleCloseWithReset();
    }
  };

  const debouncedFetchUserInfo = useCallback(
    debounce(async (newInputValue, setEmployeeSuggestions) => {
      try {
        const employeeInfo = await fetchUserInfoFromZoho(newInputValue);
        const activeEmployees = employeeInfo.filter(
          (employee) =>
            convertEmployeeStatusToValue(employee.employeestatus) === 1,
        );
        setLoadingEmployeeList(false);
        setEmployeeSuggestions(activeEmployees);
      } catch (error) {
        setLoadingEmployeeList(false);
        setEmployeeSuggestions([]);
      }
    }, 3000), // 3 seconds delay
    [],
  );

  const handleInputChange = async (event, newInputValue) => {
    if (newInputValue.length >= 3) {
      setLoadingEmployeeList(true);
      debouncedFetchUserInfo(newInputValue, setEmployeeSuggestions);
    } else {
      setLoadingEmployeeList(false);
      setEmployeeSuggestions([]);
    }
  };

  const handleEmpEmailChange = (event) => {
    setEmployeeEmailValue(event.target.value);
  };

  const handleEmpIDChange = (event) => {
    setEmployeeIDValue(event.target.value);
  };
  const handleAutocompleteChange = (event, newValue) => {
    setEmployeeNameValue(newValue ? newValue.fullName : '');
    setEmployeeEmailValue(newValue ? newValue.emailId : '');
    setEmployeeIDValue(newValue ? newValue.employeeId : '');
    setEmployeeStatusValue(
      newValue ? convertEmployeeStatusToValue(newValue.employeestatus) : '',
    );
    setEmployeeVerticalValue(newValue ? newValue.vertical : '');
    setSelectedEmployee(newValue ? { ...newValue } : null);
    setEmployeeAutocompleteError('');
  };

  return (
    <div>
      <FormDialog
        title={
          isEditMode
            ? MAP_EDIT_CERTIFICATION_DIALOG.EDIT.TITLE_TEXT
            : MAP_EDIT_CERTIFICATION_DIALOG.MAP.TITLE_TEXT
        }
        open={modalOpen}
        handleClose={handleCloseWithReset}
        button1Action={handleCloseWithReset}
        height={370}
        dialogPaperCss="certification-map-dialog"
        dialogBodycontent={
          <>
            <div className="grid-container">
              <div className="input-container">
                <label
                  htmlFor="autocomplete-employee-name"
                  className="employee-name-label"
                >
                  Employee Name
                </label>
                <Autocomplete
                  classes={{ noOptions: styles.noOptions }}
                  value={selectedEmployee}
                  inputValue={selectedEmployee?.fullName}
                  onInputChange={handleInputChange}
                  onChange={(event, newValue) => {
                    handleAutocompleteChange(event, newValue);
                  }}
                  loading={loadingEmployeeList}
                  loadingText={
                    <div className="map-cert-employee-loading">
                      <CircularProgress size={24} />
                    </div>
                  }
                  options={employeeSuggestions}
                  isOptionEqualToValue={(option, value) =>
                    option.fullName === value.fullName
                  }
                  getOptionLabel={(option) => option.fullName || ''}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <img
                        src={option.photoSignedUrl || ProfilePicPlaceHolder}
                        alt="Profile"
                        onError={(event) => {
                          event.target.src = ProfilePicPlaceHolder;
                        }}
                        className="profile-image"
                      />
                      {`${option.fullName} . ${option.employeeId}`}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Enter employee name"
                      sx={{
                        '& .MuiInputBase-root': {
                          height: '34px',
                          padding: '0px 14px',
                        },
                        '& .MuiInputBase-input': {
                          fontSize: 'small',
                          '&::placeholder': {
                            color: 'grey',
                            fontSize: 'small',
                          },
                        },
                      }}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                    />
                  )}
                />
                {employeeAutocompleteError && (
                  <div className="employee-id-error employee-name-error">
                    <small>{employeeAutocompleteError}</small>
                  </div>
                )}
              </div>

              <CommonTextField
                label="Employee email*"
                textCss="certificatemap-id"
                className="employee-email-field"
                value={employeeEmailValue}
                onChange={handleEmpEmailChange}
                autoFocus={true}
                size="small"
                id="employee-email-text"
                disabled={true}
              />
              <CommonTextField
                label="Employee ID*"
                textCss="certificatemap-id"
                value={employeeIDValue}
                onChange={handleEmpIDChange}
                autoFocus={true}
                size="small"
                id="employee-name-text"
                InputProps={{
                  style: { backgroundColor: '#F1F5F8' }, // Inline style for background color
                }}
                disabled={true}
              />
              <div className="input-container">
                <SearchDropdown
                  label="Certification name*"
                  textCss="certificatemap-id"
                  dropdownCss="certification-dropdown"
                  options={certifications}
                  value={newCertification}
                  onChange={handleCertificationChange}
                  placeholder={ADD_EDIT_DIALOG.SELECT_CERTIFICATION}
                  autoFocus={true}
                  size="small"
                  id="employee-name-text"
                />
                {certificationNameError && (
                  <div className="employee-id-error">
                    <small>{certificationNameError}</small>
                  </div>
                )}
              </div>
              <div className="certification-date-container">
                <CommonDatePicker
                  textCss="certificatemap-id"
                  label="Certification Achieved date*"
                  minDate={dayjs('01-01-2000')}
                  maxDate={dayjs()}
                  placeholder={'Choose Date'}
                  value={certificationAchievedDateValue}
                  onChange={handleDateChange}
                />
                {achievedDateError && (
                  <div className="employee-id-error">
                    <small>{achievedDateError}</small>
                  </div>
                )}
              </div>
              <div className="certification-date-container">
                <CommonDatePicker
                  textCss="certificatemap-id"
                  label="Certification expiry date"
                  minDate={certificationAchievedDateValue || dayjs('01-01-2000')}
                  maxDate={dayjs('31-12-2099')}
                  placeholder={'Choose Date'}
                  value={expiryDateValue}
                  onChange={handleExpiryDateChange}
                />
                {expiryDateError && (
                  <div className="employee-id-error">
                    <small>{expiryDateError}</small>
                  </div>
                )}
              </div>
            </div>
            {!isEditMode && (
              <div className='note-container'>
                <p className='note'>
                  <span className='note-text'>{NOTE} </span>{MAP_EDIT_CERTIFICATION_DIALOG.NOTE_MESSAGE}
                </p>
              </div>
            )}
          </>
        }
        button1={CANCEL_TEXT}
        button2={isEditMode ? UPDATE : SAVE}
        button2Action={handleSubmit}
        cancelButtonId="map-cancel-btn"
        submitButtonId="map-submit-btn"
        dialogCss="save-button"
        button2Disabled={isSaveButtonEnabled}
      />
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        alertCss={`'add-snackbar'} ${severity}`}
      />
    </div>
  );
};
CertificationsMap.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  setRows: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  editItem: PropTypes.object,
  setIsEdit:PropTypes.func.isRequired
};

export default CertificationsMap;
